function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement, forwardRef } from "react";
import imageCache from "sprout-lib/dist/image-cache";
import { TopicOutlined, VerticalDistributeOutlined, KeyboardArrowRight, PeopleOutlined as BasePeopleOutlined, LockOutlined as BaseLockOutlined } from "sprout-ui-icons";
import { Text, Flex, Box } from "sprout-ui-primitives";
import { media } from "sprout-ui-theme";
import styled, { css } from "styled-components";
import { Image } from "../Image";
import SelectableWrapper from "./SelectableWrapper";
const StyledText = styled(Text)`
  ${media.target("touch")} {
    font-size: 16px;
  }
`;
const TopicSelectableWrapper = styled(SelectableWrapper)`
  ${({ $disabled  })=>$disabled ? css`
          user-select: auto;
          opacity: 0.3;
        ` : css`
          &[aria-selected="true"] {
            .TopicSelectableSave + .TopicSelectableIndicators {
              display: none;
            }

            .TopicSelectableSave {
              display: block;
            }
          }
        `}

  .TopicSelectableSave {
    display: none;
  }
`;
const LockOutlined = styled(BaseLockOutlined)`
  width: 18px;
  height: 18px;
`;
const PeopleOutlined = styled(BasePeopleOutlined)`
  width: 22px;
  height: 22px;
`;
const TopicSelectable = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { disabled , image , title , save , arrow , lock , contributors , depth , breadcrumbsPseudo , icon  } = props, rest = _objectWithoutProperties(props, [
        "disabled",
        "image",
        "title",
        "save",
        "arrow",
        "lock",
        "contributors",
        "depth",
        "breadcrumbsPseudo",
        "icon"
    ]);
    return /*#__PURE__*/ _jsxs(TopicSelectableWrapper, _objectSpread({
        alignItems: "center",
        height: "40px",
        px: "8px",
        borderRadius: "8px",
        ref: ref,
        $disabled: !!disabled
    }, rest, {
        children: [
            depth !== undefined && Array(depth).fill(depth).map((_, index)=>{
                return /*#__PURE__*/ _jsx(Flex, {
                    as: "span",
                    justifyContent: "center",
                    mr: "8px",
                    width: "24px",
                    height: "100%",
                    flex: "none",
                    children: /*#__PURE__*/ _jsx(Box, {
                        as: "span",
                        bg: "white.12",
                        width: "1px"
                    })
                }, index);
            }),
            image ? /*#__PURE__*/ _jsx(Flex, {
                flex: "none",
                borderRadius: "3px",
                children: /*#__PURE__*/ _jsx(Image, {
                    width: "24px",
                    height: "24px",
                    src: imageCache(image, {
                        w: 96
                    })
                })
            }) : icon ? /*#__PURE__*/ createElement(icon) : /*#__PURE__*/ createElement(depth && depth > 0 ? VerticalDistributeOutlined : TopicOutlined),
            /*#__PURE__*/ _jsxs(Box, {
                minWidth: "0",
                flex: "auto",
                ml: "16px",
                children: [
                    breadcrumbsPseudo,
                    /*#__PURE__*/ _jsx(StyledText, {
                        truncate: true,
                        fontWeight: "medium",
                        fontSize: "15px",
                        lineHeight: "normal",
                        children: title || "No title"
                    })
                ]
            }),
            save && /*#__PURE__*/ _jsx(Box, {
                bg: "yellow.200",
                px: "16px",
                borderRadius: "30px",
                className: "TopicSelectableSave",
                children: /*#__PURE__*/ _jsx(Text, {
                    as: "span",
                    fontSize: "15px",
                    fontWeight: "bold",
                    lineHeight: "32px",
                    letterSpacing: "0.04em",
                    color: "black.87",
                    children: "Save"
                })
            }),
            (arrow || contributors || lock) && /*#__PURE__*/ _jsxs(Flex, {
                flex: "none",
                color: "white.70",
                alignItems: "center",
                className: "TopicSelectableIndicators",
                children: [
                    contributors && /*#__PURE__*/ _jsx(Flex, {
                        mr: lock ? "6px" : undefined,
                        children: /*#__PURE__*/ _jsx(PeopleOutlined, {})
                    }),
                    lock && /*#__PURE__*/ _jsx(LockOutlined, {}),
                    arrow && /*#__PURE__*/ _jsx(KeyboardArrowRight, {})
                ]
            })
        ]
    }));
});
export default TopicSelectable;
